var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconResetCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.75C11.4518 1.75 14.25 4.54822 14.25 8C14.25 11.4518 11.4518 14.25 8 14.25C4.54822 14.25 1.75 11.4518 1.75 8C1.75 7.68637 1.7731 7.37814 1.81769 7.07691C1.87371 6.69853 1.59674 6.33333 1.21423 6.33333C0.905194 6.33333 0.634166 6.54686 0.58726 6.85232C0.529804 7.22649 0.5 7.60976 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C6.07911 0.5 4.32689 1.22213 3 2.40973V1.54167C3 1.19649 2.72018 0.916667 2.375 0.916667C2.02982 0.916667 1.75 1.19649 1.75 1.54167V4.04167C1.75 4.38684 2.02982 4.66667 2.375 4.66667H4.875C5.22018 4.66667 5.5 4.38684 5.5 4.04167C5.5 3.69649 5.22018 3.41667 4.875 3.41667H3.75078C4.86589 2.38235 6.3591 1.75 8 1.75Z",
    fill: "#222729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResetCircle);
export default __webpack_public_path__ + "static/media/icon-reset-circle.9dec846519efff88ab64d44e08a8ff19.svg";
export { ForwardRef as ReactComponent };